import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Button,
  Text,
} from '@grupoboticario/flora-react';
import { BiDownload } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { downloadOneFile, getReportsUrls } from 'utils/downloadUrls';
import { DetailsButton, PanelContainer, Table } from './styles';
import { ReportsDetails } from '../ReportsDetails';

export function TableReports({ reports, selected, handleSelect }: any) {
  const { cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  async function handleDownload(id: any, franshiceCode?: any) {
    try {
      const filesUrl = await getReportsUrls(cpId, franshiceCode, [id]);
      if (filesUrl) {
        filesUrl.map((item: any) => downloadOneFile(item));
      }
    } catch (err) {
      console.log(err);
    }
  }

  const formatDate = (date: any) => {
    const newDate = new Date(date);
    const day = newDate.toLocaleString('pt-BR', { day: '2-digit' });
    const month = newDate.toLocaleString('pt-BR', { month: '2-digit' });
    const year = newDate.toLocaleString('pt-BR', { year: 'numeric' });
    const newDateString = `${day}/${month}/${year}`;
    return newDateString;
  };
  return (
    <Accordion collapsible type="single">
      <Table>
        {reports?.response.map((report: any) => {
          return (
            <AccordionItem value={`${report.id}`} as="tbody" key={report.id}>
              <tr>
                <td aria-label="Checkbox">
                  <input
                    key={report.id}
                    type="checkbox"
                    id={report.id}
                    value={report.id}
                    onChange={() => handleSelect(report.id, report.pdvNumber)}
                    checked={selected.some(
                      selection =>
                        selection.report === report.id &&
                        selection.code === report.pdvNumber,
                    )}
                  />
                </td>
                <td style={{ paddingLeft: '2rem' }}>
                  <Text
                    size="bodyMediumShort"
                    title={report.pdvNumber}
                    isTruncated
                  >
                    PDV {report.pdvNumber}
                  </Text>
                </td>
                <td>
                  <Text size="bodyMediumShort">
                    {formatDate(report.createdAt)}
                  </Text>
                </td>
                <td aria-label="Botão de download">
                  <Button
                    aria-label="button-download"
                    onClick={() => handleDownload(report.id, report.pdvNumber)}
                    has="iconOnly"
                    size="small"
                    hierarchy="tertiary"
                    icon={<BiDownload />}
                  />
                </td>
                <DetailsButton>
                  {report.files.length > 1 && <AccordionButton />}
                </DetailsButton>
              </tr>
              {report.files.length > 1 && (
                <tr>
                  <PanelContainer colSpan={12}>
                    <AccordionPanel>
                      <ReportsDetails
                        files={report?.files}
                        idCertificate={report.id}
                        pdvNumber={report.pdvNumber}
                      />
                    </AccordionPanel>
                  </PanelContainer>
                </tr>
              )}
            </AccordionItem>
          );
        })}
      </Table>
    </Accordion>
  );
}
